/* Rich Text Pro (easy-rich-text) — typewriter effect for headings.
   Loaded only when a heading block has the effect enabled.
   Motion parity: speed 50ms/char, no initial delay, blinking cursor. */
(function () {
  'use strict';

  var SPEED = 50;

  // Decode HTML entities safely (detached textarea: nothing is executed).
  function decodeEntities(html) {
    var textarea = document.createElement('textarea');
    textarea.innerHTML = html;
    return textarea.value;
  }

  function typewrite(element) {
    // Preserve multi-line headings: the title is rendered with newline_to_br,
    // so type line by line, appending a real <br> as each line completes.
    var originalHTML = element.innerHTML;
    var lines = originalHTML.split(/<br\s*\/?>(?:\n)?/i).map(decodeEntities);
    if (!lines.join('\n').trim()) return;

    element.textContent = '';
    element.classList.add('ert-typing');

    var lineIndex = 0;
    var charIndex = 0;
    var textNode = document.createTextNode('');
    element.appendChild(textNode);

    (function typeChar() {
      var line = lines[lineIndex];
      if (charIndex < line.length) {
        charIndex += 1;
        textNode.data = line.substring(0, charIndex);
        setTimeout(typeChar, SPEED);
      } else if (lineIndex < lines.length - 1) {
        lineIndex += 1;
        charIndex = 0;
        element.appendChild(document.createElement('br'));
        textNode = document.createTextNode('');
        element.appendChild(textNode);
        setTimeout(typeChar, SPEED);
      } else {
        // Restore the exact original markup so the final state is byte-identical.
        element.innerHTML = originalHTML;
        element.classList.remove('ert-typing');
      }
    })();
  }

  function init(scope) {
    var elements = (scope || document).querySelectorAll('.easy-rich-text [data-typewriter]');
    Array.prototype.forEach.call(elements, function (element) {
      if (element.dataset.ertTypewriterInit) return;
      element.dataset.ertTypewriterInit = 'true';
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      typewrite(element);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
